import { FiEdit, FiTrash2 } from "react-icons/fi";
import Button from "../../../components/button/button";
import ImageRenderer from "../../../components/ImageRender/ImageRender"; 

export const columns = (handleEdit, handleDelete) => [
  {
    label: 'Imagen',
    accessor: 'thumbnail',
    key: 'thumbnail',
    render: (row) => {
      return <ImageRenderer thumbnail={row.thumbnail} />;
  }
  },
  { label: 'Referencia', accessor: 'referencia', key: 'referencia' },
  { label: 'Nombre', accessor: 'nombreDotacion', key: 'nombreDotacion' },
  // { label: "Descripción", accessor: "descripcion", key: 'descripcion'},
];
